<template>
  <div>
    <h5>前台權限<span class="icon-right" @click="createMedAppP = true"> + </span></h5>
    <transition name="fade">
      <div class="create-form" v-if="createMedAppP">
        <p>新增前台權限樣板 <span class="icon-right" @click="createMedAppP = false"> X </span></p>
        <div class="form-group">
          <label for="">名稱</label>
          <input type="text" class="form-control" v-model="medAppName">
        </div>
        <div class="form-check form-check-inline" 
          v-for="field in fields.medApp"
          v-if="field.name !== 'name' && field.name !== '__slot:action'">
          <label class="form-check-label">
            <input class="form-check-input" 
              type="checkbox" 
              :value="field.name"
              v-model="checkedMedApp">{{ field.title }}
          </label>
        </div>
        <button class="btn btn-primary" @click="addMedAppP">新增</button>
      </div>
    </transition>


    <vuetable ref="vuetableMedApp"
    :api-url="`${server}/api/med-app-privilege/`"
    data-path=""
    pagination-path=""
    :fields="fields.medApp"
    :api-mode="true"
    :css="boostrapCss"
    :http-options="httpOptions"
    detail-row-component="user-group-settings-detail"
    @vuetable:cell-clicked="onCellClicked">
      <template slot="action" slot-scope="props">
        <button class="btn btn-danger" @click="deleteMedAppP(props.rowData.id)">刪除</button>
      </template>
    </vuetable>

    <hr>


    <h5>後台權限 <span class="icon-right" @click="createServerP = true"> + </span></h5>
    <div class="create-form" v-if="createServerP">
      <p>新增後台權限樣板 <span class="icon-right" @click="createServerP = false"> X </span></p>
      <div class="form-group">
        <label for="">名稱</label>
        <input type="text" class="form-control" v-model="serverName">
      </div>
      <div class="form-check form-check-inline" 
        v-for="field in fields.server"
        v-if="field.name !== 'name' && field.name !== '__slot:action'">
        <label class="form-check-label">
          <input class="form-check-input" 
            type="checkbox" 
            :value="field.name"
            v-model="checkedServer">{{ field.title }}
        </label>
      </div>
      <button class="btn btn-primary" @click="addServerP">新增</button>
    </div>

    <vuetable ref="vuetableServer"
    :api-url="`${server}/api/server-privilege/`"
    data-path=""
    pagination-path=""
    :fields="fields.server"
    :api-mode="true"
    :css="boostrapCss"
    :http-options="httpOptions"
    @vuetable:cell-clicked="onCellClicked">
      <template slot="action" slot-scope="props">
        <button class="btn btn-danger" @click="deleteServerP(props.rowData.id)">刪除</button>
      </template>
    </vuetable>

  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import UserGroupSettingsDetail from './UserGroupSettingsDetail';


Vue.component('user-group-settings-detail', UserGroupSettingsDetail);

export default {
  name: 'UserGroupSettings',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-bordered table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: {
        server: [
          {
            name: 'name',
            title: '名稱',
          },
          {
            name: 'adc_management',
            title: '藥櫃管理',
            callback: 'humanlized',
          },
          {
            name: 'tag_management',
            title: '標籤管理',
            callback: 'humanlized',
          },
          {
            name: 'report_output',
            title: '紀錄報表',
            callback: 'humanlized',
          },
          {
            name: 'data_import',
            title: '資料匯入',
            callback: 'humanlized',
          },
          {
            name: 'system_setting',
            title: '系統設定',
            callback: 'humanlized',
          },
          {
            name: '__slot:action',
            title: '動作',
          },
        ],
        medApp: [
          {
            name: 'name',
            title: '名稱',
          },
          {
            name: 'fetch',
            title: '取藥',
            callback: 'humanlized',
          },
          {
            name: 'return_drug',
            title: '退藥',
            callback: 'humanlized',
          },
          {
            name: 'inventory',
            title: '盤點',
            callback: 'humanlized',
          },
          // {
          //   name: 'plan_create',
          //   title: '預排新增',
          // },
          // {
          //   name: 'plan_remove',
          //   title: '預排移除',
          // },
          // {
          //   name: 'plan_refill',
          //   title: '預排補藥',
          // },
          // {
          //   name: 'recheck',
          //   title: '覆核',
          // },
          {
            name: 'remove_outdated',
            title: '移除過期藥物',
            callback: 'humanlized',
          },
          {
            name: 'create',
            title: '新增',
            callback: 'humanlized',
          },
          {
            name: 'remove',
            title: '移除',
            callback: 'humanlized',
          },
          {
            name: 'refill',
            title: '補藥',
            callback: 'humanlized',
          },
          {
            name: '__slot:action',
            title: '動作',
          },
        ],
      },
      checkedServer: [],
      checkedMedApp: [],
      createServerP: false,
      createMedAppP: false,
      medAppName: '',
      serverName: '',
    };
  },
  components: {
    Vuetable,
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    humanlized(value) {
      if (value) {
        return '<h6>是</h6>';
      }
      return '<h6>否</h6>';
    },
    addMedAppP() {
      const data = {};
      this.checkedMedApp.forEach((item) => {
        data[item] = true;
      });
      data.name = this.medAppName;

      this.instance.post('/api/med-app-privilege/', data)
      .then((res) => {
        this.$refs.vuetableMedApp.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功',
        });
        this.createMedAppP = false;
      });
    },
    deleteMedAppP(id) {
      this.instance.delete(`/api/med-app-privilege/${id}/`)
      .then((res) => {
        this.$refs.vuetableMedApp.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
      });
    },
    addServerP() {
      const data = {};
      this.checkedServer.forEach((item) => {
        data[item] = true;
      });
      data.name = this.serverName;

      this.instance.post('/api/server-privilege/', data)
      .then((res) => {
        this.$refs.vuetableServer.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '新增成功',
        });
        this.createServerP = false;
      });
    },
    deleteServerP(id) {
      this.instance.delete(`/api/server-privilege/${id}/`)
      .then((res) => {
        this.$refs.vuetableServer.refresh();
        this.$store.commit('SET_MESSAGE', {
          type: 'success',
          context: '刪除成功',
        });
      });
    },
  },
  // computed: mapState({
  //   system: state => state.system,
  // }),
};
</script>

<style lang="sass">

</style>





// WEBPACK FOOTER //
// UserGroupSettings.vue?6a0e3556